/* eslint-disable react/prop-types */
import React from 'react';
import { Triangle, Rectangle } from './Shapes';
// import Konva from 'konva';
// import { SoundBankOne } from './SoundBanks';

// const textureList = Object.keys(SoundBankOne);

function BrushShape (props) {
  if (props.selectedFormIndex === 0) {
    return (
        <Rectangle
            {...props}
            // fill={SoundBankOne[textureList[props.selectedTextureIndex]].color}
            // key={props.selectedTexture.selectedTextureIndex}
        />
    );
  } else if (props.selectedFormIndex === 1) {
    return (
        <React.Fragment>
        <Triangle
            {...props}
            type="triangleLeft"
            // fill={SoundBankOne[textureList[props.selectedTextureIndex]].color}
            // key={props.selectedTexture.selectedTextureIndex}
        />
        </React.Fragment>
    );
  } else {
    return (
        <React.Fragment>
        <Triangle
            // ref={shapeRef}
            {...props}
            type="triangleRight"
            // //fill={SoundBankOne[textureList[props.selectedTextureIndex]].color}
            // key={props.selectedTexture.selectedTextureIndex}
        />
        </React.Fragment>
    );
  };
}

export default BrushShape;

export const BrushRectangle = (props) => {
  return (
        <React.Fragment>
        <Rectangle
            width = {100}
            // height = {100}
            {...props}
        />
        </React.Fragment>
  );
};

export const BrushTriangleLeft = (props) => {
  return (
        <React.Fragment>
        <Triangle
            type="triangleLeft"
            width = {100}
            // height = {100}
            {...props}
        />
        </React.Fragment>
  );
};

export const BrushTriangleRight = (props) => {
  return (
        <React.Fragment>
        <Triangle
          type="triangleRight"
          width = "100"
          height = "100"
          {...props}
        />
        </React.Fragment>
  );
};
